// // import {
// //   Table,
// //   Pagination,
// //   TableHeader,
// //   TableColumn,
// //   TableBody,
// //   TableRow,
// //   TableCell,
// // } from "@nextui-org/react";
// // import { useClientTable } from "./useClientTable";
// // import * as React from "react";
// // import { Avatar } from "app/components/avatar/avatar";
// // import { useBreakpoint } from "app/utils/useBreakpoint";
// // import { MobileCrmCard } from "app/subframe/components/MobileCrmCard";
// // import { truncate } from "lodash";
// //
// // export interface ClientTableProps {
// //   rowsPerPage: number;
// //   onClientRowClick: (id: number) => void;
// // }
// //
// // export const ClientTable: React.FC<ClientTableProps> = ({
// //   rowsPerPage,
// //   onClientRowClick,
// // }) => {
// //   const {
// //     isLoading,
// //     setIsLoading,
// //     page,
// //     sortDescriptor,
// //     setSortDescriptor,
// //     sortedItems,
// //     totalCount,
// //     handlePageChange,
// //   } = useClientTable({
// //     rowsPerPage,
// //   });
// //
// //   const { isBelowSm } = useBreakpoint("sm");
// //
// //   if (isBelowSm) {
// //     return (
// //       <div className="flex w-112 mb-36 min-h-[100dvh] flex-col items-center gap-2 mobile:w-full mobile:flex-col mobile:gap-2 mobile:py-0">
// //         {sortedItems.map((sale: any) => (
// //           <MobileCrmCard
// //             name={sale.name}
// //             email={sale.email}
// //             onClick={() => onClientRowClick(sale.id)}
// //           />
// //         ))}
// //
// //         <Pagination
// //           isCompact
// //           showControls={false}
// //           variant="light"
// //           color="default"
// //           classNames={{
// //             item: "transparent",
// //             wrapper: "!shadow-none",
// //             base: "mt-6 mobile:my-6",
// //           }}
// //           page={page}
// //           total={Math.ceil(totalCount / rowsPerPage)}
// //           onChange={(page) => handlePageChange(page)}
// //         />
// //       </div>
// //     );
// //   } else {
// //     const renderCell = (client: any, columnKey: any) => {
// //       const cellValue = client[columnKey];
// //
// //       switch (columnKey) {
// //         case "id":
// //           return (
// //             <div className="flex flex-col">
// //               <p className="text-gray-800 text-sm">{cellValue}</p>
// //             </div>
// //           );
// //         case "name":
// //           return (
// //             <div className="flex items-center gap-2">
// //               <Avatar
// //                 src={client.avatar}
// //                 name={cellValue}
// //                 type="character"
// //                 className="rounded w-6 h-8"
// //               />
// //               <p className="text-gray-800 text-sm">
// //                 {isBelowSm
// //                   ? truncate(cellValue, { length: 6, omission: ".." })
// //                   : cellValue}
// //               </p>
// //             </div>
// //           );
// //
// //         case "email":
// //           return (
// //             <div className="flex flex-col">
// //               <p className="text-gray-800 text-sm">{cellValue}</p>
// //             </div>
// //           );
// //         case "phone":
// //           return (
// //             <div className="flex flex-col">
// //               <p className="text-gray-800 text-sm">{cellValue}</p>
// //             </div>
// //           );
// //         default:
// //           return cellValue;
// //       }
// //     };
// //
// //     const pages = Math.ceil(totalCount / rowsPerPage);
// //
// //     return (
// //       <Table
// //         isStriped
// //         bottomContent={
// //           <div className="flex w-full justify-center pt-8">
// //             <Pagination
// //               isCompact
// //               showControls={pages > 1}
// //               variant="light"
// //               color="default"
// //               classNames={{
// //                 item: "transparent !rounded-none",
// //                 wrapper: "!shadow-none",
// //               }}
// //               showShadow={false}
// //               page={page}
// //               total={pages}
// //               onChange={(page) => handlePageChange(page)}
// //             />
// //           </div>
// //         }
// //         isHeaderSticky
// //         sortDescriptor={sortDescriptor}
// //         onSortChange={setSortDescriptor}
// //         classNames={{
// //           base: "h-[88vh]",
// //           wrapper: "min-h-[222px] border-none shadow-none p-0",
// //           thead: "bg-white shadow-none border-none !rounded-none",
// //           th: "bg-transparent font-normal",
// //           tr: "h-12 cursor-pointer hover:bg-[#D1F4E0] !shadow-none",
// //         }}
// //       >
// //         <TableHeader>
// //           <TableColumn allowsSorting key="id">
// //             #
// //           </TableColumn>
// //           <TableColumn allowsSorting key="name">
// //             Name
// //           </TableColumn>
// //           <TableColumn allowsSorting key="email">
// //             Email
// //           </TableColumn>
// //           <TableColumn allowsSorting key="phone">
// //             Phone
// //           </TableColumn>
// //         </TableHeader>
// //         <TableBody items={sortedItems}>
// //           {(item: any) => (
// //             <TableRow key={item.id} onClick={() => onClientRowClick(item.id)}>
// //               {(columnKey) => (
// //                 <TableCell className="">
// //                   {renderCell(item, columnKey)}
// //                 </TableCell>
// //               )}
// //             </TableRow>
// //           )}
// //         </TableBody>
// //       </Table>
// //     );
// //   }
// // };
//
//
// import {
//   Table,
//   Pagination,
//   TableHeader,
//   TableColumn,
//   TableBody,
//   TableRow,
//   TableCell,
// } from "@nextui-org/react";
// import { useClientTable } from "./useClientTable";
// import * as React from "react";
// import { Avatar } from "app/components/avatar/avatar";
// import { useBreakpoint } from "app/utils/useBreakpoint";
// import { MobileCrmCard } from "app/subframe/components/MobileCrmCard";
// import { truncate } from "lodash";
// import { PencilSquareIcon, TrashIcon, UserIcon } from "@heroicons/react/24/outline";
//
// export interface ClientTableProps {
//   rowsPerPage: number;
//   onClientRowClick: (id: number) => void;
// }
//
// export const ClientTable: React.FC<ClientTableProps> = ({
//                                                           rowsPerPage,
//                                                           onClientRowClick,
//                                                         }) => {
//   const {
//     isLoading,
//     page,
//     sortDescriptor,
//     setSortDescriptor,
//     sortedItems,
//     totalCount,
//     handlePageChange,
//   } = useClientTable({
//     rowsPerPage,
//   });
//
//   const { isBelowSm } = useBreakpoint("sm");
//
//   if (isBelowSm) {
//     return (
//         <div className="flex w-112 mb-36 min-h-[100dvh] flex-col items-center gap-2 mobile:w-full mobile:flex-col mobile:gap-2 mobile:py-0">
//           {sortedItems.map((client: any) => (
//               <MobileCrmCard
//                   key={client.id}
//                   name={client.name}
//                   email={client.email}
//                   onClick={() => onClientRowClick(client.id)}
//               />
//           ))}
//           <Pagination
//               isCompact
//               variant="light"
//               color="default"
//               page={page}
//               total={Math.ceil(totalCount / rowsPerPage)}
//               onChange={(page) => handlePageChange(page)}
//               classNames={{
//                 wrapper: "!shadow-none",
//                 base: "mt-6 mobile:my-6",
//               }}
//           />
//         </div>
//     );
//   }
//
//   const renderCell = (client: any, columnKey: string) => {
//     switch (columnKey) {
//       case "name":
//         return (
//             <div className="flex items-center">
//               <div className="w-10 h-10 bg-blue-100 rounded-full flex items-center justify-center mr-3">
//                 {client.avatar ? (
//                     <Avatar src={client.avatar} name={client.name} type="character" />
//                 ) : (
//                     <UserIcon className="w-5 h-5 text-blue-600" />
//                 )}
//               </div>
//               <div>
//                 <div className="text-sm font-medium text-gray-900">{client.name}</div>
//                 <div className="text-sm text-gray-500">ID: {client.id.toString().padStart(4, "0")}</div>
//               </div>
//             </div>
//         );
//       case "email":
//         return (
//             <>
//               <div className="text-sm text-gray-900">{client.email}</div>
//               <div className="text-sm text-gray-500">{client.phone}</div>
//             </>
//         );
//       case "totalSpent":
//         return (
//             <div className="text-sm font-semibold text-green-600">
//               ${client.totalSpent?.toLocaleString() ?? "0"}
//             </div>
//         );
//       case "visits":
//         return <div className="text-sm">{client.visits ?? 0}</div>;
//       case "lastVisit":
//         return <div className="text-sm">{client.lastVisit ?? "-"}</div>;
//       case "joinDate":
//         return <div className="text-sm">{client.joinDate ?? "-"}</div>;
//       case "actions":
//         return (
//             <div className="flex space-x-2">
//               <button
//                   onClick={(e) => {
//                     e.stopPropagation();
//                     // open edit drawer
//                   }}
//                   className="p-1 text-gray-400 hover:text-gray-600"
//               >
//                 <PencilSquareIcon className="w-4 h-4" />
//               </button>
//               <button
//                   onClick={(e) => {
//                     e.stopPropagation();
//                     // delete client
//                   }}
//                   className="p-1 text-red-400 hover:text-red-600"
//               >
//                 <TrashIcon className="w-4 h-4" />
//               </button>
//             </div>
//         );
//       default:
//         return null;
//     }
//   };
//
//   const pages = Math.ceil(totalCount / rowsPerPage);
//
//   return (
//       <Table
//           sortDescriptor={sortDescriptor}
//           onSortChange={setSortDescriptor}
//           bottomContent={
//             <div className="flex w-full justify-center pt-8">
//               <Pagination
//                   isCompact
//                   showControls={pages > 1}
//                   variant="light"
//                   color="default"
//                   page={page}
//                   total={pages}
//                   onChange={(page) => handlePageChange(page)}
//                   classNames={{
//                     item: "transparent !rounded-none",
//                     wrapper: "!shadow-none",
//                   }}
//               />
//             </div>
//           }
//           // classNames={{
//           //   base: "h-[88vh]",
//           //   wrapper: "min-h-[222px] border-none shadow-none p-0",
//           //   thead: "bg-white shadow-none border-none",
//           //   tr: "h-12 cursor-pointer hover:bg-[#D1F4E0]",
//           // }}
//
//           classNames={{
//                         base: "h-[88vh]",
//                         wrapper: "min-h-[222px] border-none shadow-none p-0",
//                         thead: "bg-gray-50 shadow-none border hover:bg-gray-50",
//                         th: "bg-transparent font-normal",
//                         tr: "h-14 cursor-pointer !shadow-none",
//                       }}
//
//       >
//
//
//         <TableHeader>
//           <TableColumn className={'font-medium'} allowsSorting key="name">CLIENT</TableColumn>
//           <TableColumn className={'font-medium'} key="email" allowsSorting>CONTACT</TableColumn>
//           <TableColumn className={'font-medium'} key="totalSpent">TOTAL SPENT</TableColumn>
//           <TableColumn className={'font-medium'} key="visits">VISITS</TableColumn>
//           <TableColumn className={'font-medium'} key="lastVisit">LAST VISIT</TableColumn>
//           <TableColumn className={'font-medium'} key="joinDate">JOIN DATE</TableColumn>
//           <TableColumn className={'font-medium'} key="actions">ACTIONS</TableColumn>
//         </TableHeader>
//         <TableBody items={sortedItems}>
//           {(item: any) => (
//               <TableRow className={'!py-2'} key={item.id} onClick={() => onClientRowClick(item.id)}>
//                 {(columnKey) => <TableCell>{renderCell(item, columnKey.toString())}</TableCell>}
//               </TableRow>
//           )}
//         </TableBody>
//       </Table>
//   );
// };



import * as React from "react";
import { useClientTable } from "./useClientTable";
import { useBreakpoint } from "app/utils/useBreakpoint";
import { MobileCrmCard } from "app/subframe/components/MobileCrmCard";
import { Avatar } from "app/components/avatar/avatar";
import { Eye, Trash2, User } from "lucide-react"; // using lucide icons for consistency
import { Pagination } from "@nextui-org/react";
import {useManageClients} from "../../useManageClients";
import {format} from "date-fns";

export interface ClientTableProps {
    rowsPerPage: number;
    onClientRowClick: (id: number) => void;
    handleDeleteClient: (id: number) => void;
    handleViewClient: (client: any) => void;
}

export const ClientTable: React.FC<ClientTableProps> = ({
                                                            rowsPerPage,
                                                            onClientRowClick,
                                                            handleDeleteClient,
                                                            handleViewClient,
                                                        }) => {
    const {
        page,
        sortDescriptor,
        setSortDescriptor,
        sortedItems,
        totalCount,
        handlePageChange,
    } = useClientTable({ rowsPerPage });

    const { isBelowSm } = useBreakpoint("sm");
    const pages = Math.ceil(totalCount / rowsPerPage);

    // 👉 Mobile UI
    if (isBelowSm) {
        return (
            <div className="flex w-full mb-36 min-h-[100dvh] flex-col items-center gap-2">
                {sortedItems.map((client: any) => (
                    <MobileCrmCard
                        key={client.id}
                        name={client.name}
                        email={client.email}
                        // ClientsPage has no client drawer; open the same view modal as the desktop eye button
                        onClick={() => handleViewClient(client)}
                    />
                ))}

                <Pagination
                    isCompact
                    variant="light"
                    color="default"
                    page={page}
                    total={pages}
                    onChange={(p) => handlePageChange(p)}
                    classNames={{
                        wrapper: "!shadow-none",
                        base: "mt-6",
                    }}
                />
            </div>
        );
    }

    // 👉 Desktop UI
    const formatCurrency = (value: number) =>
        `$${value?.toLocaleString() ?? "0"}`;

    return (
        <div className="overflow-x-auto">
            <table className="w-full">
                <thead className="bg-gray-50 border-b border-gray-200">
                <tr>
                    <th className="text-left px-6 py-3 text-xs font-medium text-gray-500 uppercase tracking-wider">
                        Client
                    </th>
                    <th className="text-left px-6 py-3 text-xs font-medium text-gray-500 uppercase tracking-wider">
                        Contact
                    </th>
                    <th className="text-left px-6 py-3 text-xs font-medium text-gray-500 uppercase tracking-wider">
                        Total Spent
                    </th>
                    <th className="text-left px-6 py-3 text-xs font-medium text-gray-500 uppercase tracking-wider">
                        Visits
                    </th>
                    <th className="text-left px-6 py-3 text-xs font-medium text-gray-500 uppercase tracking-wider">
                        Last Visit
                    </th>
                    <th className="text-left px-6 py-3 text-xs font-medium text-gray-500 uppercase tracking-wider">
                        Client Since
                    </th>
                    <th className="text-left px-6 py-3 text-xs font-medium text-gray-500 uppercase tracking-wider">
                        Actions
                    </th>
                </tr>
                </thead>

                <tbody className="bg-white divide-y divide-gray-200">
                {sortedItems.map((client: any) => (
                    <tr
                        key={client.id}
                        className="hover:bg-gray-50 cursor-pointer"
                        // onClick={() => onClientRowClick(client.id)}
                    >
                        {/* Client column */}
                        <td className="px-6 py-4 whitespace-nowrap">
                            <div className="flex items-center">
                                <div className="w-10 h-10 bg-blue-100 rounded-full flex items-center justify-center">
                                    {client.avatar ? (
                                        <Avatar
                                            src={client.avatar}
                                            name={client.name}
                                            type="character"
                                        />
                                    ) : (
                                        <User className="h-5 w-5 text-blue-600" />
                                    )}
                                </div>
                                <div className="ml-4">
                                    <div className="text-sm font-medium text-gray-900">
                                        {client.name}
                                    </div>
                                    <div className="text-sm text-gray-500">
                                        ID: {client.id.toString().padStart(4, "0")}
                                    </div>
                                </div>
                            </div>
                        </td>

                        {/* Contact column */}
                        <td className="px-6 py-4 whitespace-nowrap">
                            <div className="text-sm text-gray-900">{client.email}</div>
                            <div className="text-sm text-gray-500">{client.phone}</div>
                        </td>

                        {/* Total Spent */}
                        <td className="px-6 py-4 whitespace-nowrap">
                <span className="text-sm font-medium text-green-600">
                  {formatCurrency(client.totalSpent)}
                </span>
                        </td>

                        {/* Visits */}
                        <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                            {client.visits ?? 0}
                        </td>

                        {/* Last Visit */}
                        <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                            {client.lastVisit
                                ? new Date(client.lastVisit)?.toLocaleDateString("en-US", {
                                    year: "numeric",
                                    month: "2-digit",
                                    day: "2-digit",
                                })
                                : "Never"}
                        </td>

                        {/* Join Date */}
                        <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                            {format(client?.createdAt, "MM/dd/yyyy")}
                        </td>

                        {/* Actions */}
                        <td
                            className="px-6 py-4 whitespace-nowrap"
                            onClick={(e) => e.stopPropagation()}
                        >
                            <div className="flex items-center space-x-2">
                                <button
                                    onClick={() => handleViewClient(client)}
                                    className="p-1 text-gray-400 hover:text-blue-600"
                                >
                                    <Eye className="h-4 w-4" />
                                </button>
                                <button
                                    onClick={() => handleDeleteClient(client.id)}
                                    className="p-1 text-gray-400 hover:text-red-600"
                                >
                                    <Trash2 className="h-4 w-4" />
                                </button>
                            </div>
                        </td>
                    </tr>
                ))}
                </tbody>
            </table>

            {/* Pagination */}
            <div className="flex w-full justify-center pt-6">
                <Pagination
                    isCompact
                    showControls={pages > 1}
                    variant="light"
                    color="default"
                    page={page}
                    total={pages}
                    onChange={(p) => handlePageChange(p)}
                    classNames={{
                        item: "transparent !rounded-none",
                        wrapper: "!shadow-none",
                    }}
                />
            </div>
        </div>
    );
};
